import {Controller} from '@hotwired/stimulus';
import * as Leaflet from 'leaflet';
import {SimpleMapScreenshoter} from 'leaflet-simple-map-screenshoter'
import parkingImage from '../../images/parking.svg';
import Axios from "../axios";

export default class extends Controller {

    isAdmin;

    initialize() {

        const context = this;
        context.isAdmin = false;

        // wp_localize_script
        if (typeof theme !== 'undefined') {
            if (theme.isAdmin) {
                context.isAdmin = theme.isAdmin;
            }
        }

        const image_height = 1840
        const image_width = 910
        const imageBounds = [[0, image_width], [image_height, 0]];

        const map = Leaflet.map('parking', {
            zoom: 0,
            maxZoom: 1,
            minZoom: 0,
            crs: Leaflet.CRS.Simple,
            zoomSnap: 0.5,
            zoomDelta: 0.5,
            scrollWheelZoom: false,
            renderer: Leaflet.canvas()
        }).setView([0, 0], 0);

        map.setMaxBounds(new Leaflet.LatLngBounds(imageBounds[0], imageBounds[1]));
        Leaflet.imageOverlay(parkingImage, imageBounds).addTo(map);

        Leaflet.FixedSizeMarker = Leaflet.Marker.extend({
            options: {
                fontSize: 14, // starting size of icon in pixels
                zoomBase: 0 // Zoom level where fontSize is the correct size
            },
            update: function () {
                if (this._icon && this._icon.tagName === 'DIV' && this._map) {

                    const zoom = this._map.getZoom();
                    const base = this.options.zoomBase;

                    let size = this.options.fontSize * Math.pow(2, ( zoom - base));
                    this._icon.style.fontSize = size + 'px';

                    let width = this.options.width * Math.pow(2, ( zoom - base));
                    this._icon.style.width = width + 'px';
                    this._icon.style.marginLeft = "" + (-(width / 2)) + 'px';

                    let height = this.options.height * Math.pow(2, ( zoom - base));
                    this._icon.style.height = height + 'px';
                    this._icon.style.marginTop = "" + (-(height / 2)) + 'px';

                }
                return Leaflet.Marker.prototype.update.call(this);
            }
        });
        Leaflet.fixedSizeMarker = (latlng, options) => new Leaflet.FixedSizeMarker(latlng, options);

        const markerData = [];
        this.fetchParkPlaceData().then(response => {

            if (response && response.data) {
                response.data.forEach(data => {
                    markerData[data['id']] = data
                })
            }

            context.placeMarkers(map, markerData);

        }).catch(reason => {
            console.log(reason);
        })

        context.takeScreenShot(map);
    }

    placeMarkers(map, $markerData) {

        const context = this;
        const popup = Leaflet.popup();
        const options = { color: '#009EE3', weight: 1 }

        context.parkPlaces().forEach((park) => {

            const id = park['id'];
            let width = park['width'];
            let height = park['height'];
            let styles = park['align'];
            let hasData = false;
            let data = {
                'id': '',
                'number': '?',
                'owner': '',
                'plate': '?',
            }

            if ($markerData[id]) {
                data = $markerData[id];
                hasData = true;
            }

            let nameShort = data['owner'];
            if (context.isAdmin && nameShort === '') {
                nameShort = id;
            }

            if (nameShort && nameShort.length > 8) {
                nameShort = nameShort.substring(0, 7);
                nameShort += '.';
            }

            if (styles) {
                switch (styles) {
                    case "left":
                        styles = 'display: flex; align-items: center;position: absolute; top: 2px; bottom: 0; left: 0; padding: 0 2px;';
                        break;
                    case "right":
                        styles = 'display: flex; align-items: center;position: absolute; top: 2px; bottom: 0; right: 0; padding: 0 2px;';
                        break;
                    case "top":
                        styles = 'display: flex; align-items: center;position: absolute; top: 0; left: 0; right: 0; padding-top: 4px; padding-bottom: 2px; transform: rotate(-180deg); writing-mode: vertical-lr;';
                        break;
                    case "bottom":
                        styles = 'display: flex; align-items: center;position: absolute; bottom: 0; left: 0; right: 0; padding-bottom: 4px; padding-top: 2px; transform: rotate(-180deg); writing-mode: vertical-lr;';
                        break;
                    default:
                        styles = '';
                        break;
                }
            }

            if (park['custom'] === 1) {
                styles += 'transform: rotate(16deg); top: 0; width: 100%; justify-content: flex-end;';
            }

            if (park['custom'] === 2) {
                styles += 'transform: rotate(16deg); top: 10px; width: 100%;';
            }

            const content = context.markerContent(id, data['number'], data['owner'], data['plate'], data['type'], context.isAdmin);
            let lat = park['lat'];
            let lng = park['lng'];

            if (park['lat2']) {

                const points = [
                    [ park['lat'], park['lng'] ],
                    [ park['lat2'], park['lng2'] ]
                ];

                let rectangle = Leaflet.rectangle(points, options);
                //rectangle.addTo(map);
                let center = rectangle.getBounds().getCenter();
                lat = center.lat;
                lng = center.lng;
                height = park['lat2'] - park['lat'];
                width = park['lng2'] - park['lng'];
            }

            const divIcon = new Leaflet.DivIcon({
                className: 'parking-icon',
                iconSize: new Leaflet.Point(width, height),
                iconAnchor: [0, height / 2],
                html: `<span class="park-place" style="${styles}">${nameShort}</span>`
            });

            Leaflet.fixedSizeMarker({lat: lat, lng: lng}, {
                icon: divIcon,
                fontSize: 14,
                zoomBase: 0,
                width: width,
                height: height
            }).addTo(map).on('click', function(e) {
                if (hasData || context.isAdmin) {
                    popup.setLatLng(e.latlng).setContent(content).openOn(map);
                }
            });
        })
    }

    markerContent(id, parkID, owner, plate, type, isAdmin) {

        let content = '';
        if (isAdmin) {
            content += '<p>ID: <strong>'+ id +'</strong></p>';
        }


        if (parkID) content += `<p>Stovėjimo vieta: <strong>${parkID}</strong></p>`;
        if (owner) content += `<p>Priklauso: <strong>${owner}</strong></p>`;
        if (plate) content += `<p>Valst. nr.: <strong>${plate}</strong></p>`;
        if (type) content += `<p>Tipas: <strong>${type}</strong></p>`;

        if (isAdmin) {
            content += '<a href="/wp-json/api/parking-edit?id='+ id +'">Redaguoti</a>';
        }

        return content;
    }

    async fetchParkPlaceData() {

        let response = null;
        try {
            response = await Axios.get(`/wp-json/api/parking-list`);
            response = response.data.data;
        } catch (error) {
            response = error.response.data.data;
        }

        return response;
    }

    // https://github.com/grinat/leaflet-simple-map-screenshoter
    takeScreenShot(map) {

        const adminParkingContent = document.querySelector('body.wp-admin .custom-notice')
        if (adminParkingContent) {

            const pdfGenerateButton = adminParkingContent.querySelector('#generate-pdf');
            pdfGenerateButton.addEventListener("click", async (e) => {
                e.preventDefault()

                const pdfDownLoadButton = adminParkingContent.querySelector('.generate-pdf-wrap .download-pdf');
                if (pdfDownLoadButton) pdfDownLoadButton.remove();

                pdfGenerateButton.setAttribute("disabled", "true");
                const btnText = pdfGenerateButton.innerHTML;
                pdfGenerateButton.innerHTML = "Generuojama...";

                let pluginOptions = {
                    cropImageByInnerWH: true,
                    hidden: true,
                    preventDownload: true,
                    hideElementsWithSelectors: ['.leaflet-control-container', '.leaflet-popup-pane', '.leaflet-tooltip-pane'],
                }

                const axiosConfig = {
                    headers: { 'Content-Type': 'text/plain' },
                }

                const simpleMapScreenshoter = L.simpleMapScreenshoter(pluginOptions).addTo(map)
                let format = 'image' // 'image' - return base64, 'canvas' - return canvas
                simpleMapScreenshoter.takeScreen(format).then(async image => {

                    let response = null
                    try {
                        response = await Axios.post(`/wp-json/api/parking-pdf`, image, axiosConfig)
                        response = response.data.data
                    } catch (error) {
                        response = error.response.data.data
                    }

                    pdfGenerateButton.innerHTML = btnText;
                    pdfGenerateButton.removeAttribute("disabled");

                    adminParkingContent.querySelector('.generate-pdf-wrap').insertAdjacentHTML("beforeend",
                        `<a class="download-pdf" target="_blank" href="${response.data}">Atsisiųsti PDF</a>`
                    );

                }).catch(e => {
                    pdfGenerateButton.innerHTML = "Įvyko klaida";
                    console.error(e)
                })
            });
        }
    }

    parkPlaces() {
        return [
            // 1
            {'id': 0, 'lat': 1673, 'lng': 242, 'lat2': 1692, 'lng2': 282, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 1, 'lat': 1652, 'lng': 242, 'lat2': 1671, 'lng2': 282, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 2, 'lat': 1631, 'lng': 242, 'lat2': 1650, 'lng2': 282, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 3, 'lat': 1619.5, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 4, 'lat': 1598.5, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 5, 'lat': 1577.5, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 6, 'lat': 1556.5, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 7, 'lat': 1535.5, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 8, 'lat': 1514.5, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 9, 'lat': 1493.5, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 10, 'lat': 1472.5, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 11, 'lat': 1451.5, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 12, 'lat': 1430.5, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 13, 'lat': 1409.5, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 14, 'lat': 1388.5, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 15, 'lat': 1367.5, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 16, 'lat': 1346.5, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            // 2
            {'id': 17, 'lat': 1682.5, 'lng': 304, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 18, 'lat': 1661.5, 'lng': 304, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 19, 'lat': 1640.5, 'lng': 304, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 20, 'lat': 1619.5, 'lng': 304, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 21, 'lat': 1598.5, 'lng': 304, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 22, 'lat': 1577.5, 'lng': 304, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 23, 'lat': 1556.5, 'lng': 304, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 24, 'lat': 1535.5, 'lng': 304, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 25, 'lat': 1514.5, 'lng': 304, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 26, 'lat': 1493.5, 'lng': 304, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 27, 'lat': 1472.5, 'lng': 304, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 28, 'lat': 1451.5, 'lng': 304, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 29, 'lat': 1430.5, 'lng': 304, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 30, 'lat': 1409.5, 'lng': 304, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 31, 'lat': 1388.5, 'lng': 304, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 32, 'lat': 1367.5, 'lng': 304, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 33, 'lat': 1346.5, 'lng': 304, 'width': 40, 'height': 19, 'align': 'left'},
            // 3
            {'id': 34, 'lat': 1268, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 35, 'lat': 1247, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 36, 'lat': 1226, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 37, 'lat': 1205, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 38, 'lat': 1184, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 39, 'lat': 1163, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 40, 'lat': 1142, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 44, 'lat': 1121, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 45, 'lat': 1100, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 46, 'lat': 1079, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 47, 'lat': 1058, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 48, 'lat': 1037, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 49, 'lat': 1016, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 50, 'lat': 995, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 51, 'lat': 974, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 52, 'lat': 953, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            {'id': 53, 'lat': 932, 'lng': 262, 'width': 40, 'height': 19, 'align': 'right'},
            // 4
            {'id': 54, 'lat': 1268, 'lng': 305, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 55, 'lat': 1247, 'lng': 305, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 56, 'lat': 1226, 'lng': 305, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 57, 'lat': 1205, 'lng': 305, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 58, 'lat': 1184, 'lng': 305, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 59, 'lat': 1163, 'lng': 305, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 60, 'lat': 1142, 'lng': 305, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 61, 'lat': 1121, 'lng': 305, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 62, 'lat': 1100, 'lng': 305, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 63, 'lat': 1079, 'lng': 305, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 64, 'lat': 1058, 'lng': 305, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 65, 'lat': 1037, 'lng': 305, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 66, 'lat': 1016, 'lng': 305, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 224, 'lat': 995, 'lng': 305, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 67, 'lat': 974, 'lng': 305, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 68, 'lat': 953, 'lng': 305, 'width': 40, 'height': 19, 'align': 'left'},
            {'id': 69, 'lat': 932, 'lng': 305, 'width': 40, 'height': 19, 'align': 'left'},
            // 5
            {'id': 70, 'lat': 1622, 'lng': 419, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 71, 'lat': 1622, 'lng': 440, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 72, 'lat': 1622, 'lng': 461, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 73, 'lat': 1622, 'lng': 482, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 74, 'lat': 1622, 'lng': 503, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 75, 'lat': 1622, 'lng': 524, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 76, 'lat': 1622, 'lng': 545, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 77, 'lat': 1622, 'lng': 566, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 78, 'lat': 1622, 'lng': 587, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 79, 'lat': 1622, 'lng': 608, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 80, 'lat': 1622, 'lng': 629, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 81, 'lat': 1622, 'lng': 650, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 82, 'lat': 1622, 'lng': 671, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 83, 'lat': 1622, 'lng': 692, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 84, 'lat': 1622, 'lng': 713, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 85, 'lat': 1622, 'lng': 734, 'width': 19, 'height': 40, 'align': 'top'},
            // 6
            {'id': 86, 'lat': 1537, 'lng': 419, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 87, 'lat': 1537, 'lng': 440, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 88, 'lat': 1537, 'lng': 462, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 89, 'lat': 1537, 'lng': 482, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 90, 'lat': 1537, 'lng': 503, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 91, 'lat': 1537, 'lng': 524, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 92, 'lat': 1537, 'lng': 545, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 93, 'lat': 1537, 'lng': 566, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 94, 'lat': 1537, 'lng': 587, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 95, 'lat': 1537, 'lng': 608, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 96, 'lat': 1537, 'lng': 629, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 97, 'lat': 1537, 'lng': 650, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 98, 'lat': 1537, 'lng': 671, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 99, 'lat': 1537, 'lng': 692, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 100, 'lat': 1537, 'lng': 713, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 101, 'lat': 1537, 'lng': 734, 'width': 19, 'height': 40, 'align': 'bottom'},
            // 7
            {'id': 102, 'lat': 1494, 'lng': 419, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 103, 'lat': 1494, 'lng': 440, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 104, 'lat': 1494, 'lng': 462, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 105, 'lat': 1494, 'lng': 482, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 106, 'lat': 1494, 'lng': 503, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 107, 'lat': 1494, 'lng': 524, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 108, 'lat': 1494, 'lng': 545, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 109, 'lat': 1494, 'lng': 566, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 110, 'lat': 1494, 'lng': 587, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 111, 'lat': 1494, 'lng': 608, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 112, 'lat': 1494, 'lng': 629, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 113, 'lat': 1494, 'lng': 650, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 114, 'lat': 1494, 'lng': 671, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 115, 'lat': 1494, 'lng': 692, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 116, 'lat': 1494, 'lng': 713, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 117, 'lat': 1494, 'lng': 734, 'width': 19, 'height': 40, 'align': 'top'},
            // 8
            {'id': 118, 'lat': 1403, 'lng': 419, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 119, 'lat': 1403, 'lng': 440, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 120, 'lat': 1403, 'lng': 462, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 121, 'lat': 1403, 'lng': 482, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 122, 'lat': 1403, 'lng': 503, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 123, 'lat': 1403, 'lng': 524, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 124, 'lat': 1403, 'lng': 545, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 125, 'lat': 1403, 'lng': 566, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 126, 'lat': 1403, 'lng': 587, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 127, 'lat': 1403, 'lng': 608, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 128, 'lat': 1403, 'lng': 629, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 129, 'lat': 1403, 'lng': 650, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 130, 'lat': 1403, 'lng': 671, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 131, 'lat': 1403, 'lng': 692, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 132, 'lat': 1403, 'lng': 713, 'width': 19, 'height': 40, 'align': 'bottom'},
            {'id': 133, 'lat': 1403, 'lng': 734, 'width': 19, 'height': 40, 'align': 'bottom'},
            // 9
            {'id': 134, 'lat': 1361, 'lng': 419, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 135, 'lat': 1361, 'lng': 440, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 136, 'lat': 1361, 'lng': 462, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 137, 'lat': 1361, 'lng': 482, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 138, 'lat': 1361, 'lng': 503, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 139, 'lat': 1361, 'lng': 524, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 140, 'lat': 1361, 'lng': 545, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 141, 'lat': 1361, 'lng': 566, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 142, 'lat': 1361, 'lng': 587, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 143, 'lat': 1361, 'lng': 608, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 144, 'lat': 1361, 'lng': 629, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 145, 'lat': 1361, 'lng': 650, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 146, 'lat': 1361, 'lng': 671, 'width': 19, 'height': 40, 'align': 'top'},
            // 10
            {'id': 147, 'lat': 1257, 'lng': 423, 'width': 27, 'height': 65, 'align': 'top'},
            {'id': 148, 'lat': 1257, 'lng': 452, 'width': 27, 'height': 65, 'align': 'top'},
            {'id': 149, 'lat': 1257, 'lng': 481, 'width': 27, 'height': 65, 'align': 'top'},
            {'id': 150, 'lat': 1257, 'lng': 510, 'width': 27, 'height': 65, 'align': 'top'},
            {'id': 151, 'lat': 1257, 'lng': 539, 'width': 27, 'height': 65, 'align': 'top'},
            {'id': 152, 'lat': 1257, 'lng': 568, 'width': 27, 'height': 65, 'align': 'top'},
            {'id': 153, 'lat': 1257, 'lng': 597, 'width': 27, 'height': 65, 'align': 'top'},
            {'id': 154, 'lat': 1257, 'lng': 626, 'width': 27, 'height': 65, 'align': 'top'},
            {'id': 155, 'lat': 1257, 'lng': 659, 'width': 34, 'height': 65, 'align': 'top'},
            {'id': 156, 'lat': 1257, 'lng': 691, 'width': 27, 'height': 65, 'align': 'top'},
            {'id': 157, 'lat': 1257, 'lng': 720, 'width': 27, 'height': 65, 'align': 'top'},
            {'id': 158, 'lat': 1245, 'lng': 745, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 159, 'lat': 1245, 'lng': 766, 'width': 19, 'height': 40, 'align': 'top'},
            {'id': 160, 'lat': 1245, 'lng': 789, 'width': 21, 'height': 40, 'align': 'top'},
            // 11
            {'id': 161, 'lat': 867, 'lng': 416, 'width': 27, 'height': 147, 'align': 'bottom'},
            {'id': 162, 'lat': 867, 'lng': 445, 'width': 27, 'height': 147, 'align': 'bottom'},
            {'id': 163, 'lat': 867, 'lng': 474, 'width': 27, 'height': 147, 'align': 'bottom'},
            {'id': 164, 'lat': 867, 'lng': 503, 'width': 27, 'height': 147, 'align': 'bottom'},
            {'id': 165, 'lat': 867, 'lng': 532, 'width': 27, 'height': 147, 'align': 'bottom'},
            {'id': 166, 'lat': 867, 'lng': 561, 'width': 27, 'height': 147, 'align': 'bottom'},
            // 12
            {'id': 167, 'lat': 778, 'lng': 591, 'width': 30, 'height': 147, 'align': 'bottom'},
            {'id': 168, 'lat': 778, 'lng': 621, 'width': 27, 'height': 147, 'align': 'bottom'},
            {'id': 169, 'lat': 778, 'lng': 650, 'width': 27, 'height': 147, 'align': 'bottom'},
            {'id': 171, 'lat': 762, 'lng': 679, 'width': 27, 'height': 174, 'align': 'bottom'},
            {'id': 172, 'lat': 762, 'lng': 708, 'width': 27, 'height': 174, 'align': 'bottom'},
            // 13
            {'id': 173, 'lat': 718, 'lng': 416, 'width': 27, 'height': 147, 'align': 'top'},
            {'id': 174, 'lat': 718, 'lng': 445, 'width': 27, 'height': 147, 'align': 'top'},
            {'id': 175, 'lat': 718, 'lng': 474, 'width': 27, 'height': 147, 'align': 'top'},
            {'id': 176, 'lat': 718, 'lng': 503, 'width': 27, 'height': 147, 'align': 'top'},
            {'id': 177, 'lat': 718, 'lng': 532, 'width': 27, 'height': 147, 'align': 'top'},
            {'id': 178, 'lat': 718, 'lng': 561, 'width': 27, 'height': 147, 'align': 'top'},
            // 14
            {'id': 179, 'lat': 768, 'lng': 177, 'width': 34, 'height': 15, 'align': 'left'},
            {'id': 180, 'lat': 751, 'lng': 177, 'width': 34, 'height': 15, 'align': 'left'},
            // 15
            {'id': 181, 'lat': 649, 'lng': 190, 'width': 28, 'height': 148, 'align': 'bottom'},
            {'id': 182, 'lat': 649, 'lng': 220, 'width': 28, 'height': 148, 'align': 'bottom'},
            {'id': 183, 'lat': 649, 'lng': 250, 'width': 28, 'height': 148, 'align': 'bottom'},
            {'id': 184, 'lat': 649, 'lng': 280, 'width': 28, 'height': 148, 'align': 'bottom'},
            {'id': 185, 'lat': 649, 'lng': 310, 'width': 28, 'height': 148, 'align': 'bottom'},
            {'id': 186, 'lat': 649, 'lng': 340, 'width': 28, 'height': 148, 'align': 'bottom'},
            // 16
            {'id': 187, 'lat': 697, 'lng': 50, 'width': 32, 'height': 18, 'align': 'left'},
            {'id': 188, 'lat': 676, 'lng': 50, 'width': 32, 'height': 19, 'align': 'left'},
            {'id': 189, 'lat': 655, 'lng': 50, 'width': 32, 'height': 19, 'align': 'left'},
            {'id': 190, 'lat': 634, 'lng': 50, 'width': 32, 'height': 19, 'align': 'left'},
            // 17
            {'id': 191, 'lat': 552, 'lng': 210, 'width': 145, 'height': 27, 'align': 'left'},
            {'id': 192, 'lat': 524, 'lng': 223, 'width': 144, 'height': 25, 'align': 'left'},
            {'id': 193, 'lat': 496, 'lng': 237, 'width': 144, 'height': 28, 'align': 'left'},
            {'id': 194, 'lat': 468, 'lng': 250, 'width': 144, 'height': 25, 'align': 'left'},
            {'id': 195, 'lat': 440, 'lng': 263, 'width': 144, 'height': 25, 'align': 'left'},
            {'id': 196, 'lat': 413, 'lng': 276, 'width': 144, 'height': 25, 'align': 'left'},
            {'id': 197, 'lat': 386, 'lng': 289, 'width': 144, 'height': 25, 'align': 'left'},
            {'id': 198, 'lat': 358, 'lng': 302, 'width': 144, 'height': 27, 'align': 'left'},
            {'id': 199, 'lat': 329, 'lng': 319, 'width': 144, 'height': 25, 'align': 'left'},
            {'id': 200, 'lat': 302, 'lng': 332, 'width': 144, 'height': 25, 'align': 'left'},
            {'id': 201, 'lat': 275, 'lng': 345, 'width': 144, 'height': 25, 'align': 'left'},
            {'id': 202, 'lat': 248, 'lng': 358, 'width': 144, 'height': 25, 'align': 'left'},
            {'id': 203, 'lat': 221, 'lng': 371, 'width': 144, 'height': 25, 'align': 'left'},
            {'id': 204, 'lat': 194, 'lng': 384, 'width': 144, 'height': 25, 'align': 'left'},
            // 18
            {'id': 205, 'lat': 626, 'lng': 650, 'width': 142, 'height': 28, 'align': 'right'},
            {'id': 206, 'lat': 596, 'lng': 650, 'width': 142, 'height': 28, 'align': 'right'},
            {'id': 207, 'lat': 567, 'lng': 679, 'width': 198, 'height': 27, 'align': 'right'},
            {'id': 208, 'lat': 538, 'lng': 705, 'width': 145, 'height': 27, 'align': 'right'},
            {'id': 209, 'lat': 508, 'lng': 705, 'width': 145, 'height': 27, 'align': 'right'},
            {'id': 210, 'lat': 480, 'lng': 705, 'width': 145, 'height': 27, 'align': 'right'},
            {'id': 211, 'lat': 451, 'lng': 705, 'width': 145, 'height': 27, 'align': 'right'},
            {'id': 212, 'lat': 422, 'lng': 705, 'width': 145, 'height': 27, 'align': 'right'},
            {'id': 213, 'lat': 394, 'lng': 705, 'width': 145, 'height': 27, 'align': 'right'},
            {'id': 214, 'lat': 364, 'lng': 705, 'width': 145, 'height': 27, 'align': 'right'},
            {'id': 215, 'lat': 336, 'lng': 705, 'width': 145, 'height': 27, 'align': 'right'},
            {'id': 216, 'lat': 306, 'lng': 705, 'width': 145, 'height': 27, 'align': 'right'},
            {'id': 217, 'lat': 278, 'lng': 705, 'width': 145, 'height': 27, 'align': 'right'},
            {'id': 218, 'lat': 248, 'lng': 705, 'width': 145, 'height': 27, 'align': 'right'},
            {'id': 219, 'lat': 220, 'lng': 705, 'width': 145, 'height': 27, 'align': 'right'},
            {'id': 220, 'lat': 190, 'lng': 705, 'width': 145, 'height': 27, 'align': 'right'},
            {'id': 221, 'lat': 162, 'lng': 705, 'width': 145, 'height': 27, 'align': 'right'},
            {'id': 222, 'lat': 132, 'lng': 705, 'width': 145, 'height': 27, 'align': 'right'},
            {'id': 223, 'lat': 104, 'lng': 705, 'width': 145, 'height': 27, 'align': 'right'},
            {'id': 225, 'lat': 53, 'lng': 705, 'width': 145, 'height': 70, 'align': 'right', 'custom': 1},
            {'id': 226, 'lat': 150, 'lng': 390, 'width': 130, 'height': 60, 'align': 'left', 'custom': 2},
        ];
    }

}
